import React, { useState, useEffect,useCallback, useRef, Component } from 'react';
import ParameterBox from "components/instruments/ParameterBox.js";
import ParameterLabelEditor from "components/effects/ParameterLabelEditor.js";
import {SEQUENCER_VIEW} from 'constants/view-modes.js';
import KeyScalingToggle from './KeyScalingToggle.js';
import Documented from 'components/help/Documented.js';
import LFOToggle from './LFOToggle.js';
import Colors from 'components/Colors.js';
import EnvelopeToggle from './EnvelopeToggle.js';
import {PIANO_ROLL} from 'constants/arrangement-modes.js';
import {MAP, DELETE, OFF} from 'constants/midi-map-modes.js';
import Tone from 'tone';
import ParameterFuture from 'effects/ParameterFuture.js';
import {updateParameter} from 'operations/actions.js';
import {setContextualHelp} from "actions/index.js";
import {setParameterToMap} from "actions/index.js";
import {setParameterSliderDown} from "actions/index.js";
import ConditionedComponent from 'components/ConditionedComponent.js';
import {setParameterMidiMapSelection} from 'actions/index.js';
import {
    deleteParameterMidiMapping,
    setTrackAutomationParameter,
    setAccumulatorParameterSelected,
    setArrangementBottomMode,
    setShowPianoRoll,
    setShowAutomation,
    setEffectParameterValue
       } from 'actions/index.js';
import {EFFECT_PARAMETER, PARAMETER_VALUE} from 'constants/contextual-help.js';
import { Badge, Label, Button, InputGroup, InputGroupAddon, InputGroupText, Input } from 'reactstrap';
import { connect } from "react-redux";
import {isNumber} from 'utils/IsNumber.js';

const DOUBLE_CLICK_TIME = 250;
const colors = new Colors();

const EffectParameterSlider = (props) => {
    const ref = useRef(undefined);
    const midiMapRef = useRef(props.midiMapMode);
    const isMouseDown = useRef(false);

    const onMouseDown = useCallback(() => {
        props.setParameterSliderDown(props.parameter);
        isMouseDown.current = true;
    }, []);

    const [showModulators, setShowModulators] = useState(
        props.parameter && props.parameter.isConnectedToAnyModulator ?
            props.parameter.isConnectedToAnyModulator() : false);
    const [editing, setEditing] = useState(false);
    const [value, setValue] = useState(props.value || (props.parameter && props.parameter.get(true)));
    const [inputValue, setInputValue] = useState(props.value || (props.parameter && props.parameter.get(true)));
    const lastDoubleClick = useRef(0);
    const root = props.root || 1;
    useEffect(() => {
        if (props.parameter && props.parameter.isConnectedToAnyModulator()) {
            setShowModulators(true);
        }
    }, [props.parameter && props.parameter.isConnectedToAnyModulator()]);

    useEffect(() => {
        if (props.isSelected) {
            scrollIntoView();
        }
    }, []);

    useEffect(() => {
        if (props.isSelected) {
            scrollIntoView();
        }
    }, [props.isSelected]);

    const scrollIntoView = () => {
        // first check if the parameter ANd the accumulator are of the
        // same track. if so, dont scroll

        if (props.parameter.isMapped && props.parameter.context) {
            if (props.parameter.isMapped.track ===
                props.parameter.context.track) {
                return;
            }
            
        }
        
        let el = ref.current;
        let parameterEl = el;

        let i=0;
        while (el) {
            if (!el || !el.className) {
                break;
            }
            if (el.className.includes("effects-view") || i >= 20) {
                break;
            }
            el = el.parentNode;
            i++;
        }

        if (!el.className && el.className.includes("effects-view")) {
            // then we check if its in the view
            let pLeft = parameterEl.offsetLeft;
            if (pLeft > el.offsetWidth) {
                el.scroll(pLeft, 0);
            } else {
                el.scroll(0, 0);
            }
        }
    }

    const operationManager = props.sequencerEngine &&props.sequencerEngine.operationManager;

    const getLFOs = useCallback(() => {
        if (!props.parameter) {
            return [];
        }
        return props.parameter.availableLFOs;
    }, [props.lfos, props.parameter]);

    const getEnvelopes = () => {
        if (!props.parameter) {
            return [];
        }

        let x = props.parameter.availableEnvelopes;
        return x;
    };

    const getMacroOverlayIfNeeded = useCallback(() => {
        let {isMacroMapping, parameter, isParameterToMap} = props;
        if (isMacroMapping && parameter && !parameter.isMapped) {
            let className = "macro-overlay";
            if (isParameterToMap) {
                className += " parameter-to-map";
            }

            if (parameter.hasMacro) {
                className += " mapped";
            }

            let style = {
            };

            if (props.parameter.hasMacro) {
                style = {
                    backgroundColor: colors.getColorForHash(parameter.hasMacro.id)
                };
            }

            let text = parameter.hasMacro && parameter.hasMacro.name;

            return (
                <div
                  onClick={(e) => {
                      e.stopPropagation();
                      if (!props.parameter.isMapped) {
                          props.setParameterToMap(props.parameter);
                      }
                  }}
                  className={className}>
                  <div className="overlay-main"></div>
                  <div className="overlay-detail" style={style}>
                    {text}
                  </div>
                </div>
            );
        }

        return '';
    }, [props.parameter, props.parameterToMap, props.isMacroMapping]);

    let [lfos, setLFOs] = useState(getLFOs());
    let [envelopes, setEnvelopes]= useState(getEnvelopes());
    let customClass = props.customClassName !== undefined ? props.customClassName : '';
    let isParameterSelected = props.isSelectedParameter;
    customClass +=  isParameterSelected ? ' selected-parameter parameter-box' : 'parameter-box';
    let step = props.refined ? 0.01 : props.step;

    useEffect(() => {
        setLFOs(getLFOs());
        setEnvelopes(getEnvelopes());
    }, [props.parameter && props.parameter.context, setEnvelopes, setLFOs]);
    
    if (props.isMidiSelected && props.midiMapMode === MAP) {
        customClass += ' midi-selected';
    }
    
    let contextualHelp = props.contextualHelp || EFFECT_PARAMETER;
    
    if (props.isSelected) {
        customClass += " accumulator-selected";
    }
    
    let id = props.parameter && props.parameter.id;
    if (id) {
        id = "parameter-" + id;
    }

    const onClickParameterName = useCallback(() => {
        if (midiMapRef.current  === MAP) {
            deleteParameterMidiMapping(props.parameter.id);
        } else if (props.sequencerEngine !== undefined) {
            setShowModulators(true);
        }

        let date = new Date().getTime();
        if (date - lastDoubleClick.current <= DOUBLE_CLICK_TIME) {
            showAutomation();
        }
        lastDoubleClick.current = date;
    }, [setShowModulators, props.parameter]);

    const showAutomation = useCallback(() => {
        props.setShowAutomation(true);
        props.setShowPianoRoll(true);
        props.setBottomMode(PIANO_ROLL);

        if (props.parameter.track) {
            let track = props.parameter.track.instrumentRack ?
                props.parameter.track.instrumentRack : props.parameter.track;
            props.setTrackAutomationParameter(track.id, props.parameter);
        }
    }, [props.parameter]);

   return (
        <div
          onContextMenu={e => {
              e.stopPropagation();
              e.preventDefault();
          }}
          ref={ref}
          id={id}
          className={customClass}
        >
          {props.isAccumulated ?
           <div
             onClick={() => props.setAccumulatorParameterSelected(
                 isParameterSelected ? undefined : props.parameter)}
             className="accumulator-corner"/> : ''}
          {getMacroOverlayIfNeeded()}
        <ParameterLabelEditor
          max={props.max}
          midiMapRef={midiMapRef}
          onMouseDown={onMouseDown}
          onClickParameterName={onClickParameterName}
          showAutomation={showAutomation}
          isMouseDown={isMouseDown}
          min={props.min}
          setShowModulators={setShowModulators}
          hideSlider={props.hideSlider}
          sequencerEngine={props.sequencerEngine}
          root={root}
          displayFunction={props.displayFunction}
          convertToRoot={props.convertToRoot}
          parameter={props.parameter}
          pLockedSteps={props.pLockedSteps}
          step={step}
          name={props.name}>
          <ConditionedComponent
            condition={props.lfoEnabled && (props.sequencerEngine === undefined || showModulators)}>
            <div className="lfo-boxes">{
                lfos && lfos.map(
                    (lfo, i) =>
                        <LFOToggle 
                          connectToLFO={props.connectToLFO}
                          key={i}
                          isToggled={props.parameter && props.parameter.isConnectedToLFO(lfo)}
                          parameter={props.parameter}
                          lfo={lfo}
                          lfos={lfos}
                          parameter={props.parameter}
                          instrument={props.instrument}
                        ></LFOToggle>)}
              {
                  envelopes && envelopes.map(
                      (envelope, i) =>
                          <EnvelopeToggle 
                            key={i}
                            isToggled={props.parameter && props.parameter.isConnectedToEnvelope(envelope)}
                            parameter={props.parameter}
                            envelope={envelope}
                            envelopes={envelopes}
                            parameter={props.parameter}
                            instrument={props.instrument}
                          />)}
              <KeyScalingToggle parameter={props.parameter}/>
            </div>
          </ConditionedComponent>
          <div className="clear-fix"/>
        </ParameterLabelEditor>
          {props.parameter && props.parameter.depthParameter &&
           props.parameter.isConnectedToAnyModulator() &&
           <ParameterBox
             display={x => Math.round(x*100) + '%'}
             min={0} max={1} width={70} label="Amount" name="" parameter={props.parameter.depthParameter}/>}
       </div>);
};

const pow = (a,b) =>
      a < 0 ? -1 * Math.pow(Math.abs(a), b) :
      Math.pow(a,b);

const mapDispatchToProps = dispatch => {
    return {
        setEffectParameterValue: (id, value) => dispatch(setEffectParameterValue(id, value)),
        setContextualHelp: (element) => dispatch(setContextualHelp(element)),
        setParameterMidiMapSelection: parameterId => dispatch(setParameterMidiMapSelection(parameterId)),
        deleteParameterMidiMapping: parameterId => dispatch(deleteParameterMidiMapping(parameterId)),
        setParameterToMap: parameter => dispatch(setParameterToMap(parameter)),
        setParameterSliderDown: parameter => dispatch(setParameterSliderDown(parameter)),
        setShowAutomation: p => dispatch(setShowAutomation(p)),
        setBottomMode: p => dispatch(setArrangementBottomMode(p)),
        setShowPianoRoll: p => dispatch(setShowPianoRoll(p)),
        setTrackAutomationParameter: (id, parameter) =>
            dispatch(setTrackAutomationParameter(id, parameter)),
        setAccumulatorParameterSelected: (param) => dispatch(
          setAccumulatorParameterSelected(param))
    }
};
 

const mapStateToProps = (state, props) => {
    if (props.parameter === undefined) {
        return {};
    }
    let id = props.parameter && props.parameter.id;

    let steps = state.keyboard.selectedPianoRollSteps;
    let pLockedSteps = steps && steps.length > 0 &&
        props.parameter && steps.filter(x => x && x.id in props.parameter.stepToValue);
    return {
        context: props.parameter && props.parameter.context,
        pLockedSteps: !pLockedSteps || pLockedSteps.length === 0 ? undefined : pLockedSteps,
        isMidiSelected: state.midi.parameterSelected && props.parameter.id === state.midi.parameterSelected,
        isSelected: props.parameter === state.effects.accumulatorParameterSelected,
        midiMapMode: state.midi.midiMapMode,
        isMacroMapping: state.effects.isMacroMapping,
        isParameterToMap: state.effects.parameterToMap && props.parameter &&
            state.effects.parameterToMap === props.parameter,
        isSelectedParameter: props.parameter && state.effects.accumulatorParameterSelected == props.parameter,
        isAccumulated: props.parameter && props.parameter.isMapped,
        depthParameter: props.parameter && props.parameter.depthParameter,
    };
};

 
export default connect(mapStateToProps, mapDispatchToProps)(EffectParameterSlider);

